module.exports = __webpack_public_path__ + "img/t4.5aa419b4.png";